import { MathV } from "../../../../math/MathV";
import { MathX } from "../../../../math/MathX";
import { LomaFunction } from "../LomaFunction";
import { LomaVariable } from "../LomaVariable";

export class Logical
{
  static functions:LomaFunction[] =
  [
    
    LomaFunction.forNumbers( "min", "values", ( values ) => Math.min( ...values )  
    ).setInfo( { en: "Returns the minimum value" }),

    LomaFunction.forVector3( "min", "values", ( values ) => MathV.minVector3( ...values ) 
    ).setInfo( { en: "Returns a vector3 with the minimum value for each component" }),
   
    LomaFunction.forNumbers( "max", "values", ( values ) => Math.max( ...values )  
    ).setInfo( { en: "Returns the maximum value" }),

    LomaFunction.forVector3( "max", "values", ( values ) => MathV.maxVector3( ...values )    
    ).setInfo( { en: "Returns a vector3 with the maximum value for each component" }),
    
    LomaFunction.forNumberIO( "abs", "value", ( value ) => Math.abs( value )  
    ).setInfo( { en: "Makes negative values positive." }),
    
    LomaFunction.forNumbers( "maxAbs", "values", ( values ) => MathX.maxAbs( ...values )    
    ).setInfo( { en: "Returns the value with the maximum absolute value" }),
   
    LomaFunction.forNumbers( "median", "values", ( values ) => MathX.median( ...values )   
    ).setInfo( { en: "Return the center element of all values sorted by value" }),

    LomaFunction.forNumbers( "average", "values", ( values ) => MathX.average( ...values )   
    ).setInfo( { en: "Returns the average value of all values" }),

    LomaFunction.forNumbersWith( 
      "clamp", [ "value", "min", "max" ], 
      ( values ) => MathX.clamp( values[ 0 ], values[ 1 ], values[ 2 ] )  
      ).setInfo( {
        en: "Limits the value to stay between the min and max value."
      }),

    LomaFunction.forNumbersWith( 
      "align", [ "baseSize", "elementSize", "alginmentNormalized" ], 
      ( values ) =>  MathX.align( values[ 0 ], values[ 1 ], values[ 2 ] )  
      ).setInfo( {
        en: "Computes the offset for aligning an object (element) to another (base). 0 is on the start, 1 on the end." 
      }
     )


  ]   
  
}